/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import ReferredPatientsReferredPatient from './ReferredPatientsReferredPatient';

/**
 * The ReferredPatientsBody model module.
 * @module model/ReferredPatientsBody
 * @version v0.3
 */
export default class ReferredPatientsBody {
  /**
   * Constructs a new <code>ReferredPatientsBody</code>.
   * @alias module:model/ReferredPatientsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ReferredPatientsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ReferredPatientsBody} obj Optional instance to populate.
   * @return {module:model/ReferredPatientsBody} The populated <code>ReferredPatientsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ReferredPatientsBody();
      if (data.hasOwnProperty('referred_patient'))
        obj.referredPatient = ReferredPatientsReferredPatient.constructFromObject(data['referred_patient']);
    }
    return obj;
  }
}

/**
 * @member {module:model/ReferredPatientsReferredPatient} referredPatient
 */
ReferredPatientsBody.prototype.referredPatient = undefined;

